module.exports = __webpack_public_path__ + "static/img/ktcu-cs-competition.8253da2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/ktcu-cs-competition.jpg
// module id = 7Xto
// module chunks = 0